import {create} from 'zustand';
import {UseExternalErrorMessageStore} from './types';

const useExternalErrorMessageStore = create<UseExternalErrorMessageStore>(set => ({
	externalErrorMessage: null,
	resetExternalErrorMessage: () => set({externalErrorMessage: null}),
	setExternalErrorMessage: (message: string) => set({externalErrorMessage: message}),
}));

export {useExternalErrorMessageStore};
